import React, {useState} from 'react';

import {
  Container,
  IconButtonTax,
  Item,
  ItemButtonTax,
  ItemButtonTaxText,
  ItemContent,
  ItemName,
  ItemTitle,
} from './styles';
import {Badge} from '../../../../../../Interface/Badges/Badge';
import {PedidoDTO} from '../../../../../../../dtos/PedidoDTO';
import {Discount, Localidade} from '../../types';
import {RFValue} from 'react-native-responsive-fontsize';
import {useTheme} from 'styled-components/native';
import {useHelpers} from '../../../../../../../context/helpers';
import {ServiceTaxModal} from '../../../../ServiceTaxModal';

type Props = {
  pedidos: PedidoDTO;
  localidade: Localidade;
  discount: Discount;
  serviceTaxValue: number;
  cashback: number;
  totalValue: number;
  isCreditCard: boolean;
  usaBaratinhas: boolean;
  descontoBaratinhas: number;
};

export function CoreResume({
  pedidos,
  localidade,
  discount,
  serviceTaxValue,
  cashback,
  isCreditCard,
  totalValue,
  usaBaratinhas,
  descontoBaratinhas,
}: Props) {
  const theme = useTheme();
  const {formatNumberToLocaleAmount} = useHelpers();
  const [showServiceTaxModal, setShowServiceTaxModal] = useState(false);

  return (
    <>
      <Container>
        <Item>
          <ItemTitle>Produto(s)</ItemTitle>
          <ItemName>
            {pedidos.quantity}x{' '}
            {pedidos.name.length >= 22
              ? pedidos.name.substring(0, 22) + '...'
              : pedidos.name}
          </ItemName>
        </Item>

        {localidade.tipo === 'C' && (
          <Item>
            <ItemTitle>Volume</ItemTitle>
            <ItemContent>
              <ItemName style={{marginRight: RFValue(6)}}>
                {pedidos.liters} {pedidos.unidade}{' '}
              </ItemName>

            </ItemContent>
          </Item>
        )}

        <Item>
            <ItemTitle>Categoria</ItemTitle>
            <ItemContent>
              <ItemName style={{marginRight: RFValue(6)}}>
                {localidade.rank === 'ouro' && (
                <Badge
                  text="Super Barato"
                  containerStyle={{
                    backgroundColor: theme.colors.gold,
                    borderColor: theme.colors.gold_dark,
                  }}
                  textStyle={{
                    color: theme.colors.gold_text,
                  }}
                />
              )}
              {localidade.rank === 'prata' && (
                <Badge
                  text="Barato"
                  containerStyle={{
                    backgroundColor: theme.colors.silver,
                    borderColor: theme.colors.silver_dark,
                  }}
                  textStyle={{
                    color: theme.colors.silver_text,
                  }}
                />
              )}

              </ItemName>

            </ItemContent>
          </Item>


        {pedidos.placa && (
          <Item>
            <ItemTitle>Placa</ItemTitle>
            <ItemName>{pedidos.placa}</ItemName>
          </Item>
        )}

        {usaBaratinhas && (
          <Item>
            <ItemTitle>BaratinhaZ</ItemTitle>
            <ItemName>
              -{formatNumberToLocaleAmount(descontoBaratinhas)}
            </ItemName>
          </Item>
        )}

        {discount?.code && (
          <Item>
            <ItemTitle>Cupom de desconto</ItemTitle>
            <ItemName>-{formatNumberToLocaleAmount(discount.value)}</ItemName>
          </Item>
        )}

       {<Item>
          <ItemButtonTax
            activeOpacity={0.7}
            onPress={() => setShowServiceTaxModal(true)}>
            <ItemButtonTaxText>Entenda a taxa de serviço</ItemButtonTaxText>
            <IconButtonTax name="chevron-right" />
          </ItemButtonTax>
        </Item>}


      </Container>

      <ServiceTaxModal
        onDismiss={() => setShowServiceTaxModal(false)}
        showModal={showServiceTaxModal}
        taxa={serviceTaxValue}
        liters={pedidos.liters}
        cashback={cashback}
        value={totalValue}
        isCard={isCreditCard}
      />
    </>
  );
}
